import { create } from 'zustand';
export const useUiStore = create((set, get) => ({
    backgroundUrl: 'https://schedule.ucdir.com/images/backgrounds/get-connected-1.jpg',

    setBackgroundUrl: (url) => {
        set({
            backgroundUrl: url
        });
    }
}));
